module.exports = __webpack_public_path__ + "static/media/substack.5faf68aa.svg";